import React from 'react';

export const RouteLoadingFallback: React.FC = () => {
  return (
    <div
      aria-busy="true"
      aria-label="Loading page content"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '48px 24px',
        color: 'var(--color-text-secondary)',
        fontSize: '0.95rem',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
        <div
          style={{
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            border: '3px solid var(--color-border)',
            borderTopColor: 'var(--color-accent)',
            animation: 'spin 1s linear infinite',
          }}
        />
        <span>Loading page…</span>
      </div>
    </div>
  );
};
